import React from 'react'
import { CardElement } from 'react-stripe-elements'

class CardSection extends React.Component {
  render() {
    return (
      <label className="mt-6 block">
        Card details
        <CardElement
          hidePostalCode={true}
          className="border-b pt-2 pb-2"
          style={{
            base: {
              '::placeholder': {
                color: '#22292f',
                opacity: 1
              }
            }
          }}
        />
      </label>
    )
  }
}

export default CardSection
